import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import {
  CampagneAdressesService,
  CampagnePlanificationService,
  CampagneTypologieService,
  GlobalDataService,
} from '@core/services';
import { Router } from '@angular/router';
import { CampagneService } from '@core/services/campagne.service';
import { CampagneIdentificationService } from '@core/services/campagne-identification.service';
import { HelpComponent } from 'app/campagne/components';

@Component({
  selector: 'app-bienvenue',
  templateUrl: './bienvenue.component.html',
  styleUrls: ['./bienvenue.component.scss'],
})
export class BienvenueComponent implements OnInit, AfterViewInit {
  @Input()
  public goToCampaignsState = false;

  public loaded = false;

  constructor(
    private _campagneService: CampagneService,
    private _globalDataService: GlobalDataService,
    private _router: Router,
    private _CampagneTypologieService: CampagneTypologieService,
    private _CampagneAdressesService: CampagneAdressesService,
    private _CampagnePlanificationService: CampagnePlanificationService,
    private _CampagneIdentificationService: CampagneIdentificationService,
    private _HelpComponent: HelpComponent
  ) {}

  public ngOnInit(): void {
    const count = 0;

    if (count > 0) {
      this.goToCampaignsState = true;
    }
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.loaded = true;
    });
  }

  public goToNewCampaign(): void {
    this._globalDataService.resetForNewCampaign();
    this._CampagneAdressesService.reset();
    this._CampagnePlanificationService.reset();
    this._CampagneTypologieService.reset();
    this._CampagneIdentificationService.reset();
    this._globalDataService.saveNavViewState(['nouvelle-campagne'], 'STANDALONE');
    this._router.navigate(['/standalone/home', { outlets: { navview: ['nouvelle-campagne'] } }], {
      queryParams: this._globalDataService.objectParams,
      queryParamsHandling: 'merge',
      skipLocationChange: false,
    });
  }

  public goToCampaigns(): void {
    this._globalDataService.saveNavViewState(
      ['suivi-campagnes', this._globalDataService.Annonceur.IdAnnonceur],
      'STANDALONE'
    );

    this._router
      .navigate(
        [
          '/standalone/home',
          {
            outlets: {
              navview: [
                'suivi-campagnes',
                this._globalDataService.Annonceur.IdAnnonceur,
              ],
            },
          },
        ],
        {
          queryParams: this._globalDataService.objectParams,
          queryParamsHandling: 'merge',
          skipLocationChange: false,
        }
      )
      .then((e) => {
        if (e) {
          console.log('Navigation is successful!');
        } else {
          console.log('Navigation has failed!');
        }
      });
  }

  public isBtnSuiviCampagneEnable(): boolean {
    return this._globalDataService.availableCamapgnes?.length === 0;
  }

  public openHelp(): void {
    this._globalDataService.referenceDocHelp = '';
    this._HelpComponent.OpenHelpFile();
  }

  private loadNewCampaign(campagne: any): void {
    if (typeof campagne === 'object' && campagne?.IdCampagne) {
      /**
       * Campagne existante en création.
       * On doit aller vers campagne-details / IdCampagne
       * et sauvegarder cette route dans le localStorage.
       */
      this._globalDataService.initialise();

      this._globalDataService.Campagne = campagne;

      this._CampagneAdressesService.reset();
      this._CampagnePlanificationService.reset();
      this._CampagneTypologieService.reset();
      this._CampagneIdentificationService.reset();

      this._globalDataService.isLoaded = true;

      this._globalDataService.saveNavViewState(
        ['campagne-details', this._globalDataService.Campagne.IdCampagne],
        'STANDALONE'
      );

      this._router
        .navigate(
          [
            '/standalone/home',
            {
              outlets: {
                navview: [
                  'campagne-details',
                  this._globalDataService.Campagne.IdCampagne,
                ],
              },
            },
          ],
          {
            queryParams: this._globalDataService.objectParams,
            queryParamsHandling: 'merge',
            skipLocationChange: false,
          }
        )
        .then((e) => {
          if (e) {
            console.log('Navigation is successful!');
          } else {
            console.log('Navigation has failed!');
          }
        });
    } else {
      /**
       * Aucune campagne courante côté backend.
       * Ici seulement on va vers nouvelle-campagne.
       * On évite de sauvegarder campagne-details avec un IdCampagne vide.
       */
      this._globalDataService.isLoaded = true;

      this._globalDataService.saveNavViewState(
        ['nouvelle-campagne'],
        'STANDALONE'
      );

      this._router
        .navigate(
          ['/standalone/home', { outlets: { navview: ['nouvelle-campagne'] } }],
          {
            queryParams: this._globalDataService.objectParams,
            queryParamsHandling: 'merge',
            skipLocationChange: false,
          }
        )
        .then((e) => {
          if (e) {
            console.log('Navigation is successful!');
          } else {
            console.log('Navigation has failed!');
          }
        });
    }

    this._globalDataService.campagneBeforeChanges = Object.assign(
      {},
      this._globalDataService.Campagne
    );
  }
}
